// extracted by mini-css-extract-plugin
module.exports = {"page_loader_wrapper":"styles_page_loader_wrapper__24Kl-","show":"styles_show__1C2NU","loader":"styles_loader__1PAnn","lds-roller":"styles_lds-roller__1-C16"};